import { updateAll } from '@/api/devis';
import { ATTENTE_REPONSE } from '@/configuration/optionBlocage/optionBlocage';

function getLignesWithAvertissement(lignes, devis) {
  if (!devis.messagesAvertissement) return null;
  const avertissements = [];
  devis.messagesAvertissement.forEach((message) => {
    const produitId = message.errorMessage.split('@')[1].split('@')[0];
    const anneeSemaine = message.errorMessage.split('@')[3].split('|')[0];
    const ligneFind = lignes.find((ligne) => {
      return ligne.anneeSemaine === Number(anneeSemaine) && ligne.produitId === produitId;
    });
    if (ligneFind) {
      const ligneInDevis = devis.lignesCommande.find((ligne) => {
        return ligne.id === ligneFind.ligneId;
      });
      avertissements.push({
        id: ligneInDevis.id,
        etatObtenuReponse: ligneInDevis.etatObtenuReponse,
      });
    }
  });
  return avertissements;
}

export default async function updateDevis(lignes, allDevis) {
  // filtre sur les devis à update
  const devisToUpdateIds = lignes.filter((ligne) => {
    return allDevis.map(d => d.id).includes(ligne.devisId);
  }).map(l => l.devisId);
  const devisToUpdate = allDevis.filter(d => devisToUpdateIds.includes(d.id));
  // set etatObtenuReponse dans l'updateDto
  devisToUpdate.forEach(devis => {
    devis.lignesCommande.forEach((ligneCommande) => {
      const ligneWithDevisIdFind = lignes.find((ligne) => {
        return ligne.ligneId === ligneCommande.id;
      });
      ligneCommande.etatObtenuReponse = ligneWithDevisIdFind
        ? ligneWithDevisIdFind.etatObtenuReponse : ATTENTE_REPONSE;
    });
  });
  // update
  const devisOutputs = (await updateAll({ updateDtos: devisToUpdate })).data.result;
  let avertissements = [];
  devisOutputs
    .filter(d => d.messagesAvertissement)
    .forEach(d => {
      const lignesWithDevisId = lignes.filter((ligne) => { return ligne.devisId === d.id; });
      avertissements = avertissements.concat(getLignesWithAvertissement(lignesWithDevisId, d));
    });
  return avertissements;
}
